export function compactList(values: readonly string[], empty: string): string {
  if (values.length === 0) return empty;
  if (values.length === 1) return values[0]!;
  return `${values[0]} +${values.length - 1}`;
}

const reportFilterNumber = new Intl.NumberFormat("en-GB", {
  maximumFractionDigits: 20,
});

export function numericRangeSummary(
  min: number | null,
  max: number | null,
  empty = "Any",
): string {
  if (min === null && max === null) return empty;
  return `${reportFilterNumber.format(min ?? 0)}–${max === null ? "∞" : reportFilterNumber.format(max)}`;
}
